/* eslint-disable */
const hash = {
  "en-US": "50e5038f",
  "de-DE": "78739765",
  "es-ES": "6dbf2588",
  "fr-FR": "f0843355",
  "id-ID": "27d4e5cd",
  "it-IT": "042ccc9c",
  "jp-JP": "c4be1ce3",
  "ko-KO": "c4b2bfb2",
  "nl-NL": "cb66b1fa",
  "pl-PL": "c24dfdee",
  "pt-PT": "02c4132f",
  "ru-RU": "1fb8263c",
  "tr-TR": "4f61e455",
  "vi-VN": "dd4773e2",
  "zh-CN": "f600e644",
  "zh-TW": "93ef6d82",
  "sv-SE": "670fdf2f",
  "control": "8cea0e9c",
  "plan-details": "9e4504b4",
  "gov-EN": "9ffeba5b",
  "en-GB": "3ff830c5"
}
export default hash
